// pages/admins/permissions/PermissionStateBadge.jsx
//
// Renders WHAT a permission's value is -- Allowed / Denied / Inherited /
// Partial (mixed, module-level only) / Not available -- as one small
// icon+color pill. Deliberately separate from PermissionSourceBadge (WHERE
// the value comes from: Role vs. User Override vs. System): the two used to
// be blended into a single badge, which is exactly the "hard to tell role
// vs. override at a glance" complaint this redesign addresses.
import React from "react";
import { Badge } from "react-bootstrap";

const STATE_META = {
  ALLOWED: { label: "Allowed", icon: "fa-circle-check", cls: "pm-state-allowed" },
  DENIED: { label: "Denied", icon: "fa-circle-xmark", cls: "pm-state-denied" },
  INHERITED: { label: "Inherited", icon: "fa-diagram-project", cls: "pm-state-inherited" },
  PARTIAL: { label: "Partial", icon: "fa-adjust", cls: "pm-state-partial" },
  DISABLED: { label: "Not available", icon: "fa-lock", cls: "pm-state-disabled" },
};

export default function PermissionStateBadge({ state, label, size = "md" }) {
  const meta = STATE_META[state] || STATE_META.DISABLED;
  return (
    <Badge bg={null} className={`pm-state-badge ${meta.cls} pm-state-badge-${size}`}>
      <i className={`fa-solid ${meta.icon}`} aria-hidden="true"></i>
      {label || meta.label}
    </Badge>
  );
}

export { STATE_META };
